import {byIdOrThrow} from './commons'

interface OtpCountdownOptions {
  lifetime: number
  countdownId: string
  language: string
  done: () => any
}

(function(exports) {

  let _interval = undefined

  function doCountdown(opt: OtpCountdownOptions) {
    const delta = opt.lifetime - new Date().getTime()

    const countdownElem = byIdOrThrow(opt.countdownId)

    const hours = Math.floor((delta % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((delta % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((delta % (1000 * 60)) / 1000)

    const options = { minimumIntegerDigits: 2 };
    countdownElem.innerHTML = hours.toLocaleString(opt.language, options)
      + ':' + minutes.toLocaleString(opt.language, options)
      + ':' + seconds.toLocaleString(opt.language, options)

    if (delta <= 0) {
      countdownElem.innerHTML = '00:00:00';
      if (typeof opt.done === 'function') {
        opt.done()
      }
      clearInterval(_interval);
    }
  }

  function countdown(opt: OtpCountdownOptions) {
    doCountdown(opt)
    _interval = setInterval(function () {
      doCountdown(opt)
    }, 1000)
  }

  exports.otp = {
    countdown
  }

})(window['nam'] || (window['nam'] = {}))